<template>
  <div>
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t("customer_due_receive_list") }}</h4>
        </div>
      </div>

      <div v-if="can('sales.customer_due_receive', 'W')" class="page-btn">
        <router-link to="/customer/due/receive" class="btn btn-added">
          <i class="ti ti-circle-plus me-2 text-white"></i>{{ $t("new_due_receive") }}
        </router-link>
      </div>
    </div>

    <ThemeDataTable
      ref="dueReceiveTable"
      table-id="CustomerDueReceiveTable"
      :fetch-data="fetchReceiptsPage"
      :filters="tableFilters"
      default-order-dir="desc"
    >
      <template #default="{ rows }">
        <thead class="thead-light">
          <tr>
            <th>{{ $t("voucher_no") }}</th>
            <th>{{ $t("voucher_date") }}</th>
            <th class="no-sort">{{ $t("customer_name") }}</th>
            <th class="no-sort">{{ $t("customer_phone") }}</th>
            <th class="no-sort">{{ $t("payment_type") }}</th>
            <th>{{ $t("narration") }}</th>
            <th>{{ $t("total_paid_amount") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="receipt in rows" :key="receipt.id">
            <td>{{ receipt.voucher_id }}</td>
            <td>{{ receipt.voucher_date }}</td>
            <td>
              <div class="d-flex align-items-center">
                <span class="avatar avatar-md me-2">
                  <span
                    class="avatar-title rounded bg-light text-secondary d-flex align-items-center justify-content-center w-100 h-100"
                  >
                    <i class="ti ti-user"></i>
                  </span>
                </span>
                <span>{{ receipt.customer_name || '—' }}</span>
              </div>
            </td>
            <td>{{ receipt.customer_phone || '—' }}</td>
            <td>{{ receipt.payment_method || '—' }}</td>
            <td>{{ receipt.narration || '—' }}</td>
            <td>{{ formatMoney(receipt.paid_amount) }}</td>
          </tr>
        </tbody>
      </template>
    </ThemeDataTable>
  </div>
</template>

<script>
import { can as canAccess } from "@/helpers/permission";
import apiUrls from '@/urls';
import ThemeDataTable from '@/components/common/ThemeDataTable.vue';
import { truncateMoney2 } from '@/utils';

export default {
  components: {
    ThemeDataTable,
  },
  data() {
    return {
      filterOptions: {
        payment_method: [],
      },
    };
  },
  computed: {
    tableFilters() {
      return [
        {
          key: 'payment_method',
          label: this.$t('payment_type'),
          options: this.filterOptions.payment_method,
        },
      ];
    },
  },
  methods: {
    formatMoney(amount) {
      return truncateMoney2(amount);
    },

    async fetchFilterOptions() {
      try {
        const response = await this.$axios.get(apiUrls.customer_payment.get, {
          params: { filter_options: 1 },
        });
        this.filterOptions.payment_method = response.data?.payment_method || [];
      } catch (error) {
        console.error('Error fetching due receive filter options:', error);
      }
    },

    async fetchReceiptsPage({ draw, start, length, search, orderColumn, orderDir, filters }) {
      const params = {
        draw,
        start,
        length,
        'search[value]': search || '',
        'order[0][column]': orderColumn,
        'order[0][dir]': orderDir,
        ...filters,
      };

      const response = await this.$axios.get(apiUrls.customer_payment.get, { params });
      const payload = response.data || {};

      return {
        data: payload.data || [],
        recordsTotal: payload.recordsTotal || 0,
        recordsFiltered: payload.recordsFiltered || 0,
      };
    },

    can(code, requiredLevel) {
      return canAccess(code, requiredLevel);
    },
  },
  created() {
    this.fetchFilterOptions();
  },
};
</script>
